const createChipButton = (label, value) => {
  const spritePath = window.mirAssets?.manifest?.['svg/sprites.svg'] || '/build/svg/sprites.svg';
  const spriteUrl = `${window.mirAssets?.baseUrl || ''}${spritePath}`;
  const chip = document.createElement('div');
  const labelNode = document.createElement('span');
  const removeButton = document.createElement('button');
  const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const iconUse = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  const hiddenLabel = document.createElement('span');

  chip.className = 'chip';
  chip.dataset.value = value;

  labelNode.className = 'chip-label';
  labelNode.textContent = label;

  removeButton.type = 'button';
  removeButton.setAttribute('data-bs-dismiss', 'chip-select');

  icon.classList.add('icon');
  iconUse.setAttribute('href', `${spriteUrl}#it-close`);
  icon.appendChild(iconUse);

  hiddenLabel.className = 'visually-hidden';
  hiddenLabel.textContent = `Rimuovi ${label}`;

  removeButton.append(icon, hiddenLabel);
  chip.append(labelNode, removeButton);

  return chip;
};

const getSelectedValues = (select) => {
  return Array.from(select.options)
    .filter((option) => option.value !== '' && option.selected)
    .map((option) => option.value);
}

const updateSelection = (select, nextValues) => {
  const values = new Set(nextValues);
  const hasPlaceholder = Array.from(select.options).some((option) => option.value === '');

  Array.from(select.options).forEach((option) => {
    if (option.value === '') {
      option.selected = !select.multiple && values.size === 0 && hasPlaceholder;
      return;
    }

    option.selected = values.has(option.value);
  });

  if (!select.multiple && values.size === 0 && !hasPlaceholder) {
    select.selectedIndex = -1;
  }

  select.dispatchEvent(new Event('change', { bubbles: true }));
};

const renderProxyOptions = (select, proxySelect) => {
  const selectedValues = new Set(getSelectedValues(select));
  
  proxySelect.innerHTML = '';
  Array.from(select.options)
    .filter((option) => !selectedValues.has(option.value))
    .forEach((option) => {
      const proxyOption = document.createElement('option');
      proxyOption.value = option.value;
      proxyOption.textContent = option.textContent.trim();
      proxySelect.appendChild(proxyOption);
    });

  proxySelect.disabled = proxySelect.options.length <= 1;
};

const renderChips = (select, chipsContainer) => {
  chipsContainer.innerHTML = '';

  Array.from(select.options)
    .filter((option) => option.value !== '' && option.selected)
    .forEach((option) => {
      chipsContainer.appendChild(
        createChipButton(option.textContent.trim(), option.value),
      );
    });
};

const setupChipSelect = (selectContainer) => {
  const select = selectContainer.querySelector('select');

  if (!select || select.dataset.chipSelectReady === 'true') {
    return;
  }

  const originalId = select.id;
  const proxySelect = document.createElement('select');
  const chipsContainer = document.createElement('div');

  proxySelect.className = select.className;
  proxySelect.setAttribute('aria-label', select.getAttribute('aria-label'));

  if(originalId) {
    select.id = `${originalId}-source`;
    proxySelect.id = originalId;
  }

  chipsContainer.className = 'd-flex flex-wrap gap-0 mt-2';

  select.classList.add('d-none');
  select.dataset.chipSelectReady = 'true';

  select.insertAdjacentElement('afterend', proxySelect);
  proxySelect.insertAdjacentElement('afterend', chipsContainer);

  const syncUi = () => {
    renderProxyOptions(select, proxySelect);
    renderChips(select, chipsContainer);
  };

  proxySelect.addEventListener('change', () => {
    if(!proxySelect.value) {
      return;
    }

    const nextValues = select.multiple ? [...getSelectedValues(select), proxySelect.value] : [proxySelect.value];
    updateSelection(select, nextValues);
    proxySelect.value = '';
    syncUi();
  });

  chipsContainer.addEventListener('click', (event) => {
    const chip = event.target.closest('.chip[data-value]');

    if (!chip) {
      return;
    }

    const nextValues = getSelectedValues(select).filter((value) => value !== chip.dataset.value);
    updateSelection(select, nextValues);
    syncUi();
    proxySelect.focus();
  });

  select.addEventListener('change', syncUi);
  syncUi();
};

const bootstrapChipSelect = () => {
  const selects = document.querySelectorAll('.js-mir-chip-select');
  selects.forEach((select) => setupChipSelect(select));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapChipSelect);
} else {
  bootstrapChipSelect();
}
